import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { likePost, unlikePost, getPostLikesStatus } from "../../services/postService";
import "./LikeButton.css";
import { useAuth } from "../../context/AuthContext";

const LikeButton = ({ postId }) => {
    const [likes, setLikes] = useState(0);
    const [liked, setLiked] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated } = useAuth() || {};

    useEffect(() => {
        const fetchLikeStatus = async () => {
            try {
                const response = await getPostLikesStatus(postId);
                const data = response?.data;

                if (data && typeof data.likes_count === "number") {
                    setLikes(data.likes_count);
                    setLiked(!!data.liked_by_current_user);
                } else {
                    console.warn("Invalid like data from server:", data);
                }
            } catch (err) {
                console.error("Error loading like status:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchLikeStatus();
    }, [postId]);

    const handleLikeToggle = async () => {
        if (!isAuthenticated) {
            navigate("/login", { state: { from: location.pathname } });
            return;
        }
        
        try {
            let response;
            if (liked) {
                response = await unlikePost(postId);
            } else {
                response = await likePost(postId);
            }

            const newLikes = response?.data?.likes_count;
            if (typeof newLikes === "number") {
                setLikes(newLikes);
                setLiked(!liked);
            } else {
                console.warn("Unexpected like toggle response:", response);
            }
        } catch (err) {
            console.error("Failed to toggle like:", err);
        }
    };

    if (loading) return <span>❤️ ...</span>;

    return (
        <div className="like-button">
            <label className="heart-container" title="Like">
                <input
                    type="checkbox"
                    className="checkbox"
                    aria-label="Like"
                    checked={liked}
                    onChange={handleLikeToggle}
                />
                <div className="svg-container">
                    <svg viewBox="0 0 24 24" className="svg-outline" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Zm-3.585,18.4a2.973,2.973,0,0,1-3.83,0C4.947,16.006,2,11.87,2,8.967a4.8,4.8,0,0,1,4.5-5.05A4.8,4.8,0,0,1,11,8.967a1,1,0,0,0,2,0,4.8,4.8,0,0,1,4.5-5.05A4.8,4.8,0,0,1,22,8.967C22,11.87,19.053,16.006,13.915,20.313Z" />
                    </svg>
                    <svg viewBox="0 0 24 24" className="svg-filled" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z" />
                    </svg>
                    <svg className="svg-celebrate" width={100} height={100} xmlns="http://www.w3.org/2000/svg">
                        <polygon points="10,10 20,20" />
                        <polygon points="10,50 20,50" />
                        <polygon points="20,80 30,70" />
                        <polygon points="90,10 80,20" />
                        <polygon points="90,50 80,50" />
                        <polygon points="80,80 70,70" />
                    </svg>
                </div>
            </label>
            <span className="like-count">{likes}</span>
        </div>
    );
};

export default LikeButton;
